// extracted by mini-css-extract-plugin
export default {"Container":"Search_Container__IDmh7","Open":"Search_Open__K4bPV"};